<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="content">
        <div class="search-wrap">
          <div class="icon">
            <div class="icon-search">
              <img src="~@a/img/search.png" alt="" />
            </div>
          </div>
          <div class="inp-box">
            <div class="inp-text">
              <input
                v-model="searchWord"
                type="text"
                :placeholder="`${$t('name')} / ${$t('type')} / ${$t('sn')}`"
                @keydown.enter="onmotovideoSearch"
              />
            </div>
          </div>
          <div class="btn-wrap">
            <div class="btn-search" @click="onmotovideoSearch">
              {{ $t("search") }}
            </div>
          </div>
        </div>
        <div class="table-wrap">
          <el-table
            :data="motovideoListData"
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column :label="$t('updateDate')" width="180">
              <template slot-scope="scope">
                <span class="cursor" @click="onRouter(scope.row)">
                  {{ scope.row.updatetime | timeFormatDate }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('info')">
              <template slot-scope="scope">
                <span class="cursor" @click="onRouter(scope.row)">
                  {{ scope.row.title }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination" v-if="motovideoListData.length">
          <el-pagination
            layout="prev, pager, next"
            :total="totalPage"
            @current-change="onChangePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      src: require("@a/img/banner-soft.png"),
      motovideoListData: [],
      totalPage: 0,
      page: 1,
      searchWord: "",
      swiperImgs: [],
      loading: false
    };
  },
  components: {
    Swiper
  },
  created() {
    this.topingAll();
    this.motovideoList({ page: this.page });
  },
  methods: {
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 6)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    motovideoList(params) {
      this.$set(this, "loading", true);
      API.motovideoList(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "motovideoListData", res.data.data);
          this.$set(this, "totalPage", res.data.total);
          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    motovideoSearch(params) {
      this.$set(this, "loading", true);
      API.motovideoSearch(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "motovideoListData", res.data);
          this.$set(this, "totalPage", 1);
          this.$set(this, "loading", false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onChangePage(v) {
      this.$set(this, "page", v);
      this.motovideoList({ page: this.page });
    },
    onmotovideoSearch() {
      if (this.searchWord !== "") {
        this.motovideoSearch({
          str: this.searchWord
        });
      } else {
        this.$message.error(this.$t("searchTips"));
      }
    },
    onRouter(v) {
      this.$router.push({
        path: "serviceVideoDetails",
        query: {
          id: v.id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.pagination {
  margin: 40px 0;
}
.search-wrap {
  margin: 40px 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  input {
    font-size: 20px;
    width: 100%;
    background: none;
    border: none;
  }

  .icon-search {
    width: 31px;
  }

  .inp-box {
    flex-basis: 80%;
    padding: 0 10px;

    .inp-text {
      border-bottom: 1px solid var(--color-black);
    }
  }

  .btn-wrap {
    flex-basis: 15%;
  }

  .btn-search {
    cursor: pointer;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    color: var(--color-white);
    border-radius: 5px;
    background: var(--color-green);
  }
}

.table-wrap {
  margin: 20px 100px 0;
}
@media only screen and (max-width: 767px) {
  .search-wrap {
    margin: 20px 0;
  }
  .table-wrap {
    margin: 20px 0 0;
  }
}
</style>
